import cc from 'classcat'
import React, { ReactElement } from 'react'

import { reactClass } from '../../../utils'
import * as Styled from './styles'

interface ContentInnerProps {
  children: React.ReactNode
}

export const ContentInner = ({ children }: ContentInnerProps): ReactElement => {
  return <Styled.ContentInnerWrapper className={reactClass('inner-content')}>{children}</Styled.ContentInnerWrapper>
}
export type ContentProps = {
  children: React.ReactNode
  className?: string
}

export const Content = ({ children, className }: ContentProps): ReactElement => {
  return (
    <Styled.ContentWrapper className={cc([className, reactClass('content')])}>
      <ContentInner>{children}</ContentInner>
    </Styled.ContentWrapper>
  )
}
